export const state = {
  leadStatuses: [
    {
      'id': 6,
      'display_order': 1,
      'name': 'leads-web.leads.statuses.6',
      'type': 'status'
    },
    {
      'id': 3,
      'display_order': 2,
      'name': 'leads-web.leads.statuses.3',
      'type': 'status'
    },
    {
      'id': 5,
      'display_order': 3,
      'name': 'leads-web.leads.statuses.5',
      'type': 'status'
    },
    {
      'id': 4,
      'display_order': 4,
      'name': 'leads-web.leads.statuses.4',
      'type': 'status'
    },
    {
      'id': 1,
      'display_order': 5,
      'name': 'leads-web.leads.statuses.1',
      'type': 'status'
    },
  ],
  leadsWebSrvToken: process.env.VUE_APP_LEADS_WEB_INTERNAL_TOKEN
}
